
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem2ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem2ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem2ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem2ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem2ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem2ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem2ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem2ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}